import type { GitpodAPI } from "@/api";
import { createBatchLoader, type BatchLoader } from "@/queries/dataloader";
import type { PlainGroup } from "@/queries/group-queries";

export type GroupLoader = BatchLoader<PlainGroup>;

const createGroupLoader = (api: GitpodAPI): GroupLoader =>
    createBatchLoader(async (groupIds) => {
        const results = new Map<string, PlainGroup>();
        const response = await api.groupService.listGroups({
            filter: { groupIds },
        });
        for (const group of response.groups) {
            results.set(group.id, group);
        }
        return results;
    }, 25); // ListGroups.Filter.group_ids caps at 25

let sharedLoader: { loader: GroupLoader; api: GitpodAPI } | null = null;

export const getGroupLoader = (api: GitpodAPI): GroupLoader => {
    if (!sharedLoader || sharedLoader.api !== api) {
        sharedLoader = { loader: createGroupLoader(api), api };
    }
    return sharedLoader.loader;
};
